var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('div',{staticClass:"circle animate__animated animate__rubberBand animate__infinite box-center"},[_c('span',{staticClass:"animate__animated animate__bounce",attrs:{"aria-hidden":"true"}})]),_c('h2',{staticClass:"mt-5"},[_vm._v(" El presentador nos expondrá unos temas a continuación ")])])])
}]

export { render, staticRenderFns }